<template>
  <div class="root_buy_information">
    <v-col xl="8" lg="7" md="6" sm="5" xs="12">
      <BoxesProduct :items="cart" :checkoutCart="checkoutCart" />
    </v-col>
    <v-col xl="4" lg="5" md="6" sm="7" xs="12">
      <SidBarInfo :info="cart" :onClick="onClick" />
    </v-col>
  </div>
</template>
<script>
import BoxesProduct from "./BoxesProduct";
import SidBarInfo from "./SideBarInfo";

export default {
  name: "BuyInformation",
  props: ["cart", "onClick", "checkoutCart"],
  components: { BoxesProduct, SidBarInfo },
};
</script>
<style lang="scss">
.root_buy_information {
  display: flex;
}

@media only screen and (max-width: 768px) {
  .root_buy_information {
    padding: 0 10px;
  }
}

@media only screen and (max-width: 600px) {
  .root_buy_information {
    flex-direction: column;
  }
}
</style>
